import Config from "services/config/config";
import callWebService, {callTypes} from "services/utils/networks/network";
import {GET_RC_TICKET_LIST, STATUS_UPDATE} from "./type";


export const getAllRcTransfer = (page=1, leadId=null, vehicleNumber=null, leadStatus=null, submissionDate=null) => async (dispatch) => {
    let url = Config.rcTransfer.getRcTransferList + `?page=${page}`

    if(leadId!== null){
        url+= `&lead_id=${leadId}`
    }

    if(vehicleNumber!== null){
      url+= `&vehicle_number=${vehicleNumber}`
    }

    if(leadStatus!== null){
        url+= `&lead_status=${leadStatus}`
    }

    if(submissionDate!== null){
        url+= `&submission_date=${submissionDate}`
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: GET_RC_TICKET_LIST, payload: data});
      return data.response;
    }
  };


export const updateStatusRcTransfer = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.rcTransfer.statusUpdateRcTransfer}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: STATUS_UPDATE,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

